export default __webpack_public_path__ + "resources/icons/n422-1f77.png";